import { createSupabaseClient } from "../../../hooks/useSupabase";
import { SelfPatient } from "./types";

const getSelfPatient = async (
  customerEmail: string,
): Promise<SelfPatient | null> => {
  const supabase = createSupabaseClient();

  // A self-patient is a non-archived patient linked to no one (the customer is
  // the patient). More than one row can match messy data (e.g. shared emails),
  // so pick the earliest deterministically instead of erroring on multiples.
  const { data, error } = await supabase
    .from("patients")
    .select(
      "mrn, date_birth, city, state, postal_code, country, race, ethnicity, sex",
    )
    .eq("email", customerEmail)
    .is("family_contact_id", null)
    .is("legal_guardian_id", null)
    .eq("is_archived", false)
    .order("created_at", { ascending: true })
    .limit(1)
    .maybeSingle();

  if (error) return null;
  return data;
};

export default getSelfPatient;
